import React from 'react';
import { withTitle } from '../../HOC';
import useLongformGallery from './useLongformGallery';
import LongformGalleryImage from './LongformGalleryImage';

const LongformGallery = props => {
  const {
    loading,
    error,
    groupedImages,
    shouldDisplayCaption,
    caption,
    handleImageOnClick
  } = useLongformGallery(props);

  if (loading || error || !groupedImages.length) return null;

  return (
    <div className="longform-gallery" data-testid="longform-gallery">
      {groupedImages.map((imageGroup, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i} data-testid="grouped-images" className="longform-gallery__images">
          {imageGroup.map(secondaryImage => (
            <LongformGalleryImage
              key={secondaryImage.id}
              {...secondaryImage}
              numberOfImages={imageGroup.length}
              className={
                imageGroup.length > 2
                  ? 'longform-gallery__images__image secondary-image'
                  : 'longform-gallery__images__image main-image'
              }
              handleImageOnClick={handleImageOnClick}
            />
          ))}
        </div>
      ))}
      {shouldDisplayCaption && (
        <div className="carousel__details" data-testid="carousel-details">
          <div className="caption">{caption}</div>
        </div>
      )}
    </div>
  );
};

export default withTitle(LongformGallery);
